import { mediaQueriesBP } from "@dillon/Utilities/variables";
import ProductDetailsProductBadgets from "@dillon/Widgets/ProductBadges/ProductBadgets";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

export interface ProductDetailsProductBadgetsContainerStyles {
    gridContainer?: InjectableCss;
}

export const productBadgetsContainerStyles: ProductDetailsProductBadgetsContainerStyles = {
    gridContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            ${mediaQueriesBP.minMD} {
                gap: 16px;
                margin: 10px 0;
            }
        `,
    },
};

const styles = productBadgetsContainerStyles;

const ProductDetailsProductBadgetsContainer: React.FC<Props> = ({ product }) => {
    if (!product.properties.wishListFacetsBadgets) {
        return null;
    }


    const wishListFacetsBadgets = JSON.parse(product.properties.wishListFacetsBadgets || "[]");
    let filteredBadgets = wishListFacetsBadgets.filter((badge: any) => badge.productId === product.id)[0];

    if (product.isVariantParent && product.variantTraits && product.variantTraits.length > 0) {
        const idsToMatch = new Set<string>([product.id]);
        const variantsIds =
            product.variantTraits.flatMap((variant: any) => variant.traitValues?.map((tv: any) => tv.id) ?? []) ?? [];
        variantsIds.forEach(id => idsToMatch.add(id));
        const matches = wishListFacetsBadgets.flatMap((arr: any) => arr);
        const all = matches.flatMap((w: any) => w.wishlists ?? []);
        const deduped = Array.from(new Map(all.map((b: any) => [b.id, b])).values());
        filteredBadgets = { wishlists: deduped };
    }

    if (!filteredBadgets || filteredBadgets.length === 0) {
        return null;
    }

    return (
        <StyledWrapper {...styles.gridContainer}>
            {filteredBadgets.wishlists.map((badge: any) => {
                return <ProductDetailsProductBadgets key={badge.id} text={badge.name} backgroundColor={badge.color} />;
            })}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsProductBadgetsContainer),
    definition: {
        displayName: "Product Badges Container",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
